import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router";
import { Link, useNavigate, useLocation } from "react-router-dom";

import { useMapContext } from "../../../../context/MapContext";
import { useAppContext } from "../../../../context/AppContext";

import { toast } from "react-toastify";
import { Stage, Layer, Circle } from "react-konva";

import { Steps } from "primereact/steps";
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { BreadCrumb } from "primereact/breadcrumb";
import { FileUpload } from "primereact/fileupload";
import { Checkbox } from "primereact/checkbox";

import Modal from "../../../../components/modal/Modal";

import { getMapData } from "../../../../services/GlobalRoles/getMapData";
import { getMapImage } from "../../../../services/GlobalRoles/getMapImage";
import { postMapImage } from "../../../../services/GlobalRoles/postMapImage";

import GuideVideo from "../../../../assets/map-settings-guide.mp4";
import { useQuery } from "react-query";
import { getGoogleMapImage } from "../../../../services/GlobalRoles/getGoogleMapImage";
import { GoogleMaps } from "./GoogleMaps";
import { postMapLandPosition } from "../../../../services/GlobalRoles/postMapLandPosition";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { GoogleMapsLocationPicker } from "../../../../components/googleMaps/GoogleMapsLocationPicker";
import usePermission from "../../../../hooks/usePermission";
import { formatCurrency } from "../../../../utils/formatCurrency";

const MapSettings = () => {
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  usePermission("89"); // Editar Mapa

  const {
    visibleTooltip,
    setVisibleTooltip,
    selectedItem,
    tooltipPosition,
    panX,
    panY,
    handleMouseMove,
    zoom,
    setZoom,
    handleMouseUp,
    handleCanvasClick,
    currentBlock,
    setCurrentBlock,
    currentLandIndex,
    setCurrentLandIndex,
    currentIndex,
    data,
    setData,
    items,
    setItems,
    onTemplateRemove,
    setTotalSize,
    handleDragEnd,
    handleDragStart,
    updateCursorPosition,
    mouseX,
    mouseY,
    imageSize,
    setPanX,
    setPanY,
    handleMouseDown,
    handleTapCircle,
    processMapData,
    tooltipReverse,
    tooltipEnd,
    setImageDimensions,
    circleSize, setCircleSize,
    setEmpId,
    zoomMove,
    showToolTip, setShowToolTip,
    setZoomMove
  } = useMapContext();

  const { nomenclatures, permissions } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);

  const imageRef = useRef(null);
  const scrollRef = useRef(null);
  const fileInputRef = useRef(null);
  const fileInputRefMap = useRef(null);

  const [activeIndex, setActiveIndex] = useState(0);

  const [visible, setVisible] = useState(
    !localStorage.getItem("notSeeMapGuide")
  );

  const [visibleGoogleMaps, setVisibleGoogleMaps] = useState(false);
  const [closable, setClosable] = useState(true);
  const [canvasWidth, setCanvasWidth] = useState(null);
  const [modalLoading, setModalLoading] = useState(true);
  const [canvasHeight, setCanvasHeight] = useState(null);
  const [checked, setChecked] = useState(
    Boolean(localStorage.getItem("notSeeMapGuide"))
  );

  const [newMap, setNewMap] = useState(false);
  const [imageMap, setImageMap] = useState();

  const steps = [
    {
      label: "Mapa",
    },
    {
      label: "Posicionar",
    },
  ];

  useEffect(() => {
    console.log({ selectedItem })
  }, [selectedItem])

  useEffect(() => {
    if (id) {
      setEmpId(id);
    }
  }, [id])

  useEffect(() => {
    if (imageMap) {
      const imagem = new Image();
      imagem.src = imageMap;

      imagem.onload = () => {
        const { largura, altura } = imageSize(imagem);

        setCanvasWidth(largura);
        setCanvasHeight(altura);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageMap]);

  useEffect(() => {
    async function fetchData() {
      const [mapData, mapImage] = await Promise.all([
        getMapData(id),
        getMapImage(id),
      ])

      if (mapData.message) {
        navigate("/login");
      } else {
        //        console.log("Map Data: ", mapData);
        const { newItems, itemsToPosition } = processMapData(mapData);
        // Atualize os itens com os novos itens
        setItems([...newItems]);
        setData({ blocks: itemsToPosition });
        mapData.ball_size && parseInt(mapData.ball_size) !== 0 && setCircleSize(parseInt(mapData.ball_size));
        // console.log("Items to Position: ", itemsToPosition);

      }

      if (mapImage.file) {
        // setActiveIndex(1);
        setImageMap(mapImage.file);
        // setMap(true);
        localStorage.setItem("flagMap", true);
        setClosable(true);
      } else {
        setVisible(true);
      }
      setModalLoading(false);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageMap]);

  useEffect(() => {
    // console.log("Data: ", data);
    if (data && data.length !== 0 && data.blocks.length > 0) {
      setCurrentBlock(data.blocks[currentIndex]);
      setCurrentLandIndex(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, currentIndex]);

  const customBase64Uploader = async (event) => {
    // convert file to base64 encoded
    const file = event.files[0];
    const reader = new FileReader();
    const notification = toast.loading("Por favor aguarde...");
    let blob = await fetch(file.objectURL).then((r) => r.blob()); //blob:url
    if (
      ["image/png", "image/jpg", "image/jpeg", "image/webp"].includes(blob.type)
    ) {
      reader.readAsDataURL(blob);
      // console.log(blob);
      reader.onloadend = async function () {
        const base64data = reader.result;
        // console.log(base64data);
        const uploadMap = await postMapImage(id, "map", base64data);

        if (uploadMap.success) {
          toast.update(notification, {
            render: uploadMap.success.toString(),
            autoClose: 5000,
            type: "success",
            isLoading: false,
          });
          setClosable(true);
          setImageMap(uploadMap.file);
        } else {
          toast.update(notification, {
            render: "Oops, algo deu errado! Tente novamente.",
            autoClose: 5000,
            type: "error",
            isLoading: false,
          });
        }
        //        console.log("Response UpMap: ", uploadMap);
      };
    } else {
      toast.error("Tipo de arquivo inválido, tente imagens png, jpg ou webp;");
      fileInputRef.current.clear();
      setTotalSize(0);
    }
  };

  const itemTemplate = (file, props) => {
    return (
      <div className="row justify-content-center">
        <div className="row pb-4">
          <div className="col-xl-8 my-auto text-center pb-2">{file.name}</div>
          <div className="col-xl-4 text-center">
            <Button
              type="button"
              icon="pi pi-times"
              className="p-button-danger"
              label="Remover"
              onClick={() => onTemplateRemove(file, props.onRemove)}
            />
          </div>
        </div>
        <div className="col-12">
          <img
            alt={file.name}
            role="presentation"
            src={file.objectURL}
            width={"100%"}
          />
        </div>
      </div>
    );
  };

  const navigation = [
    {
      template: () => (
        <Link
          to={`/enterpriseSettings/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Configurações do Empreendimento
        </Link>
      ),
    },
    {
      template: () => (
        <Link
          to={`/enterpriseSettings/map/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Configurações do Mapa
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"/salesManagement"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  function handleVisibleGoogle() {
    setVisibleGoogleMaps(false);
  }

  function handleVisible() {
    setVisible(true);
  }

  const handleImageLoad = () => {
    if (imageRef.current) {
      setImageDimensions({
        width: imageRef.current.width,
        height: imageRef.current.height
      });
    }
  };

  const handleCircleSize = async (value) => {
    const transformedData =
      items.reduce((acc, item) => {
        acc[item.id] = {
          cx: item.x,
          cy: item.y
        };
        return acc;
      }, {})

    const sendData = {
      "data": transformedData,
      "size": value,
      "enterprise_id": id
    }

    const test = await postMapLandPosition(sendData);
    //    console.log(test);
  }

  // useEffect(() => {
  //   console.log("Zoom Move State: ", zoomMove)
  // }, [zoomMove])

  return (
    <div>
      <div className="row pb-4">
        <div className="col-md-10">
          <BreadCrumb
            model={navigation}
            home={home}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "16px",
            }}
          />
        </div>
        {permissions?.includes("92") && ( //Configurar Google Maps
          <div className="col-md-2 my-auto">
            <Button
              label="Google Maps"
              icon="fa-solid fa-map"
              size="small"
              severity="info"
              onClick={() => setVisibleGoogleMaps(!visibleGoogleMaps)}
              outlined={!visibleGoogleMaps}
              className="w-100"
            />
          </div>
        )}
      </div>

      {!visibleGoogleMaps && (
        <>
          <div
            className="row mb-4 px-2 bg-white rounded-3 fixed"
            style={{
              position: "relative",
              zIndex: "99",
            }}
          >
            <div className="col-md-3 col-6 py-4">
              <p className="text-lg">
                <b>Tamanho da Bolinha</b>
              </p>
              <input
                type="range"
                className="form-range"
                value={circleSize}
                onChange={(e) => {
                  setCircleSize(e.target.value)
                  handleCircleSize(e.target.value)
                }}
                min={2}
                max={40}
              />
            </div>
            {/* <div className="col-md-3 col-6 py-4">
              <p className="text-lg">
                <b>Zoom Mapa</b>
              </p>
              <input
                type="range"
                className="form-range"
                value={zoom}
                onChange={(e) => {
                  setZoom(e.target.value);
                  setPanX(0);
                  setPanY(0);
                }}
                min={1}
                max={10}
                step={0.1}
              />
            </div> */}
            <div className="col-md-2 py-4 my-auto">
              <Button
                label="Mapa"
                icon="pi pi-cog"
                size="small"
                onClick={handleVisible}
                outlined
                className="w-100"
              />
            </div>
            {currentBlock && currentBlock.lands[currentLandIndex] && (
              <div className="col-12 mb-4 pt-4 text-center map-instruction">
                Clique sobre a {nomenclature[0].value}:{" "}
                <b>{currentBlock.name}</b>, {nomenclature[1].value}:{" "}
                <b>{currentBlock.lands[currentLandIndex].name}</b>
              </div>
            )}
          </div>
        </>
      )}

      {visibleTooltip && selectedItem && (
        <div
          style={{
            position: "absolute",
            zIndex: "100",
            minHeight: "100px",
            pointerEvents: "none"
          }}
          className="map-instruction-desktop"
        >
          <div
            style={{
              position: "relative",
              left: tooltipPosition.left - 20, // Ajuste horizontal conforme necessário
              // com imagem: top - 280
              top: tooltipPosition.top - 150, // Ajuste o deslocamento vertical conforme necessário
              fontSize: zoom > 1 ? "6px" : "16px",
            }}
            className="bg-white px-2 py-1 rounded"
          >
            <div className="d-flex flex-column">
              <div className="d-flex">
                <p className="mt-2 ms-2">
                  {nomenclature[0].value}/{nomenclature[1].value}{" "}
                  <b>{selectedItem.land}</b>{" "}
                </p>
                <div
                  onClick={() => setVisibleTooltip(false)}
                  style={{ cursor: "pointer", pointerEvents: "auto" }}
                >
                  <i
                    className="fa-regular text-danger fa-circle-xmark ms-4"
                    style={{ marginTop: "8px", fontSize: "20px" }}
                  ></i>
                </div>
              </div>
              <div className="d-flex flex-column align-items-center mb-2">
                <div className="d-flex">
                  <h6 className="mx-2">M²: {selectedItem.m2}</h6>
                  {selectedItem.color === "#33FF3C" && (
                    <h6 className="mx-2">
                      Valor: {formatCurrency(selectedItem.value)}
                    </h6>
                  )}
                </div>
                <div className="mt-2">
                  <Button
                    label={
                      selectedItem.color === "#33FF3C"
                        ? "Fazer Simulação"
                        : `${nomenclature[1].value} indisponível`
                    }
                    disabled={selectedItem.color !== "#33FF3C"}
                    onClick={() =>
                      navigate(`/enterprise/simulator/${selectedItem.id}`, {
                        state: { empId: id },
                      })
                    }
                    style={{ pointerEvents: "auto" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {currentBlock && currentBlock.lands[currentLandIndex] && showToolTip && (
        <div
          style={{
            position: "absolute",
            zIndex: 999
          }}
          className="map-instruction-desktop"
        >
          <div
            style={{
              position: "relative",
              left: mouseX - 20,
              top: mouseY - 50,
              fontSize: '1em', // Utilize em para ajustar o tamanho da fonte de forma relativa
              padding: '0.5em', // Utilize em para ajustar o padding de forma relativa
            }}
            className="bg-white rounded"
          >
            Clique sobre a {nomenclature[0].value}:{" "}
            <b>{currentBlock.name}</b>, {nomenclature[1].value}:{" "}
            <b>{currentBlock.lands[currentLandIndex].name}</b>
            <div
              style={{
                position: "absolute",
                top: "100%", // Posicione o triângulo em relação à parte inferior do elemento pai
                left: "22px", // Centralize o triângulo horizontalmente
                transform: "translateX(-50%)", // Centralize o triângulo horizontalmente
                width: "0",
                height: "0",
                borderLeft: "10px solid transparent",
                borderRight: "10px solid transparent",
                borderTop: "10px solid white", // A cor do triângulo
              }}
              className="pin-map"
            />
          </div>
        </div>
      )}

      {(canvasWidth && !visibleGoogleMaps && items) && (
        <div className="enterprise--map">
          <TransformWrapper
            panning={{ disabled: !zoomMove, wheelPanning: true, allowRightClickPan: false, allowMiddleClickPan: false }}
          // centerOnInit={true} 
          >
            <TransformComponent>

              {window.innerWidth >= 992 ? (
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    transform: `scale(${zoom}) translate(${panX}px, ${panY}px)`,
                    transition: "transform 0.1s"
                  }}
                // onMouseDown={handleMouseDown}
                // onMouseUp={handleMouseUp}
                // onMouseMove={handleMouseMove}
                >
                  <img
                    src={imageMap}
                    ref={imageRef}
                    onLoad={handleImageLoad}
                    alt="map"
                    style={{
                      width: canvasWidth,
                      height: canvasHeight,
                      position: "absolute",
                      objectFit: "contain",
                    }}
                    name={"map"}
                  />
                  <Stage
                    width={canvasWidth}
                    height={canvasHeight}
                    // onClick={handleCanvasClick}
                    onContextMenu={handleCanvasClick}
                    // onMouseDown={handleCanvasClick}
                    onMouseMove={updateCursorPosition}
                    onMouseEnter={() => setShowToolTip(true)}
                    onMouseLeave={() => setShowToolTip(false)}
                  >
                    <Layer>
                      {items.map((item, i) => (
                        <Circle
                          key={i}
                          name={item.id.toString()}
                          draggable
                          x={item.x}
                          y={item.y}
                          radius={parseInt(circleSize)} // Tamanho fixo dos círculos
                          fill={item.color}
                          onDragStart={handleDragStart}
                          onDragEnd={handleDragEnd}
                          onPointerClick={(e) => handleTapCircle(item, e, { x: 0, y: 0 })}
                          onMouseEnter={() => setZoomMove(false)}
                          onMouseLeave={() => setZoomMove(true)}
                        />
                      ))}
                    </Layer>
                  </Stage>
                </div>
              ) : (
                <div style={{ overflow: "hidden", overflowX: "scroll" }} ref={scrollRef}>
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      transform: `scale(${zoom}) translate(${panX}px, ${panY}px)`,
                    }}
                    onMouseDown={handleMouseDown}
                    onMouseUp={handleMouseUp}
                    onMouseMove={handleMouseMove}
                  >
                    <img
                      src={imageMap}
                      ref={imageRef}
                      onLoad={handleImageLoad}
                      alt="map"
                      style={{
                        width: canvasWidth,
                        height: canvasHeight,
                        position: "absolute",
                        objectFit: "contain",
                      }}
                      name={"map"}
                    />

                    {currentBlock &&
                      currentBlock.lands[currentLandIndex] &&
                      showToolTip && (
                        <div
                          style={{
                            position: "absolute",
                          }}
                          className="map-instruction-desktop"
                        >
                          <div
                            style={{
                              position: "relative",
                              left: mouseX - 20, // Ajuste o deslocamento horizontal conforme necessário
                              top: mouseY - 50, // Ajuste o deslocamento vertical conforme necessário
                              fontSize: zoom > 1 ? "6px" : "16px",
                            }}
                            className="bg-white px-2 py-1 rounded"
                          >
                            Clique sobre a {nomenclature[0].value}:{" "}
                            <b>{currentBlock.name}</b>, {nomenclature[1].value}:{" "}
                            <b>{currentBlock.lands[currentLandIndex].name}</b>
                            <div
                              style={{
                                position: "absolute",
                                top: "100%", // Posicione o triângulo em relação à parte inferior do elemento pai
                                left: "22px", // Centralize o triângulo horizontalmente
                                transform: "translateX(-50%)", // Centralize o triângulo horizontalmente
                                width: "0",
                                height: "0",
                                borderLeft: "10px solid transparent",
                                borderRight: "10px solid transparent",
                                borderTop: "10px solid white", // A cor do triângulo
                              }}
                              className="pin-map"
                            />
                          </div>
                        </div>
                      )}

                    <Stage
                      width={canvasWidth}
                      height={canvasHeight}
                      // onClick={handleCanvasClick}
                      onContextMenu={handleCanvasClick}
                      // onMouseDown={handleCanvasClick}
                      onMouseMove={updateCursorPosition}
                      onMouseEnter={() => setShowToolTip(true)}
                      onMouseLeave={() => setShowToolTip(false)}
                    >
                      <Layer>
                        {items.map((item, i) => (
                          <Circle
                            key={i}
                            name={item.id.toString()}
                            draggable
                            x={item.x}
                            y={item.y}
                            radius={parseInt(circleSize)} // Tamanho fixo dos círculos
                            fill={item.color}
                            onDragStart={handleDragStart}
                            onDragEnd={handleDragEnd}
                            onPointerClick={(e) => handleTapCircle(item, e, { x: 0, y: 0 })}
                          />
                        ))}
                      </Layer>
                    </Stage>
                  </div>
                </div>
              )}

            </TransformComponent>
          </TransformWrapper>
        </div>
      )}

      {(!canvasWidth && !items?.length && !visibleGoogleMaps) && (
        <Skeleton width="100%" height="100vh" />
      )}

      {visibleGoogleMaps && (
        <>
          <GoogleMaps
            handleVisible={handleVisible}
            handleVisibleGoogle={handleVisibleGoogle}
          />
        </>
      )}

      <Modal
        visible={visible}
        dynamicTitle={"Configurações do Mapa"}
        onHide={() => {
          setVisible(!visible);
          setActiveIndex(0);
        }}
        closable={closable}
      >
        <div className="pt-4">
          {modalLoading ? (
            <div>
              <div className="d-flex pt-2 px-5 justify-content-between">
                <div>
                  <Skeleton width="70px" height="30px" />
                </div>
                <div>
                  <Skeleton width="90px" height="30px" />
                </div>
                <div>
                  <Skeleton width="70px" height="30px" />
                </div>
              </div>
              <div className="py-4">
                <Skeleton width="100%" height="200px" />
              </div>
              <div className="row">
                <div className="col-6">
                  <Skeleton width="100px" height="50px" />
                </div>
                <div className="col-6 text-end">
                  <Skeleton className="float-end" width="100px" height="50px" />
                </div>
              </div>
            </div>
          ) : (
            <>
              <Steps model={steps} activeIndex={activeIndex} />
              <div className="py-4">
                {activeIndex === 0 &&
                  (imageMap && !newMap ? (
                    <div>
                      <Button
                        label="Trocar Mapa"
                        onClick={() => setNewMap(true)}
                        className="my-2"
                        icon="fa-solid fa-rotate"
                      />
                      <img src={imageMap} width={"100%"} alt="map" />
                    </div>
                  ) : (
                    <>
                      <h3 className="py-3">
                        Faça o Upload do mapa do seu empreendimento
                      </h3>
                      <FileUpload
                        ref={fileInputRef}
                        name="map[]"
                        auto={true}
                        accept=".png, .jpg, .jpeg, .webp"
                        maxFileSize={8000000}
                        mode={"advanced"}
                        customUpload
                        uploadHandler={customBase64Uploader}
                        itemTemplate={itemTemplate}
                        invalidFileSizeMessageSummary={
                          "O aquivo excede o tamanho permitido de 8MB"
                        }
                        invalidFileSizeMessageDetail={
                          "Tamanho de arquivo inválido."
                        }
                        chooseLabel={"Subir mapa"}
                        cancelLabel={"Cancelar"}
                        previewWidth={50}
                        emptyTemplate={
                          <div className="text-center">
                            <p className="m-0">
                              Clique em "Subir mapa" ou arraste e solte seu mapa
                              aqui.
                            </p>
                          </div>
                        }
                      />
                    </>
                  ))}
                {activeIndex === 1 && (
                  <div>
                    <video
                      width="100%"
                      height="440"
                      controls
                      loop
                      autoplay="true"
                      muted="true"
                      playsinline
                    >
                      <source src={GuideVideo} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                )}
              </div>

              <div className="flex align-items-center pb-4">
                <Checkbox
                  inputId="notSeeMapGuide"
                  name="notSeeMapGuide"
                  onChange={(e) => {
                    setChecked(e.checked);
                    localStorage.setItem("notSeeMapGuide", e.checked);
                  }}
                  value={checked}
                  checked={checked}
                ></Checkbox>
                <label htmlFor="notSeeMapGuide" className="mx-2">
                  {" "}
                  Não mostrar esse guia novamente.
                </label>
              </div>
              <div className="row">
                <div className="col-6">
                  {activeIndex > 0 && (
                    <Button
                      icon="fa-solid fa-circle-chevron-left"
                      iconPos="left"
                      label="Anterior"
                      onClick={() => setActiveIndex(activeIndex - 1)}
                    />
                  )}
                </div>
                <div className="col-6 text-end">
                  {activeIndex <= 1 && (
                    <Button
                      iconPos="right"
                      icon={
                        activeIndex < 1
                          ? "fa-solid fa-circle-chevron-right"
                          : "fa-solid fa-circle-check"
                      }
                      label={activeIndex < 1 ? "Próximo" : "Pronto"}
                      onClick={() => {
                        if (activeIndex < 1) {
                          setActiveIndex(activeIndex + 1);
                        } else {
                          setVisible(false);
                          setActiveIndex(0);
                        }
                      }}
                    />
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default MapSettings;
